import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Pagination, Stack } from "@mui/material";
import moment from "moment";
import {
  Plus,
  Image,
  Video,
  FileText,
  Edit2,
  Trash2,
  Download,
  Calendar,
  X,
} from "lucide-react";

import { Addstocks } from "./addstocks";
import { EditStock } from "./adminStocksEdit";
import { Loader } from "./loader";
import api from "../../api";
import "./AllPostAdmin.css";

export function AllAdminStocks() {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);

  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const getPosts = async () => {
    try {
      setLoader(true);
      const res = await api.stocksGetAdmin({ page });
      setData(res.post);
      setnoOfPost(res.count);
      setLimit(res.limit);
      setLoader(false);
    } catch (err) {
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    if (!window.confirm("Are you sure you want to delete this trade?")) return;
    setLoader(true);
    await api.stocksDelete({ id });
    getPosts();
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  const withImages = data.filter((d) => d.imageTitle).length;
  const withVideos = data.filter((d) => d.video).length;
  const withFiles = data.filter((d) => d.pdfFile).length;

  return (
    <div className="crypto-trades-admin">
      {/* ================= HEADER ================= */}
      <div className="crypto-trades-header">
        <div className="content-of-header">
          <div className="title-section">
            <h2 className="crypto-trades-title">
              <span className="crypto-trades-icon">📈</span>
              Stock & Commodities Trades
            </h2>
            <p className="crypto-trades-subtitle">
              Manage and monitor all stock trading posts ({noOfPost})
            </p>
          </div>

          <button
            className="crypto-trades-add-btn"
            onClick={() => setShow(true)}
          >
            <Plus size={16} /> Add Stocks
          </button>
        </div>

        {/* ================= STATS ================= */}
        <div className="crypto-trades-stats">
          <div className="stat-card">
            <div className="stat-icon total-trades-icon">📊</div>
            <div className="stat-content">
              <div className="stat-number">{noOfPost}</div>
              <p className="stats-label">Total Trades</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon image-trades-icon">
              <Image size={20} />
            </div>
            <div className="stat-content">
              <div className="stat-number">{withImages}</div>
              <p className="stats-label">With Images</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon video-trades-icon">
              <Video size={20} />
            </div>
            <div className="stat-content">
              <div className="stat-number">{withVideos}</div>
              <p className="stats-label">With Videos</p>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon file-trades-icon">
              <FileText size={20} />
            </div>
            <div className="stat-content">
              <div className="stat-number">{withFiles}</div>
              <p className="stats-label">With Files</p>
            </div>
          </div>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="crypto-trades-table-container">
        <div className="table-card">
          <StockTable
            data={data}
            page={page}
            setPage={setPage}
            limit={limit}
            noOfPost={noOfPost}
            deletePost={deletePost}
            onEdit={(item) => {
              setSelectedData(item);
              setShowEdit(true);
            }}
            onAdd={() => setShow(true)}
          />
        </div>
      </div>

      {/* ADD MODAL */}
      <Modal show={show} size="lg" centered onHide={() => setShow(false)}>
        <Modal.Header className="modal-header-custom">
          <Modal.Title>Add New Stock Trade</Modal.Title>
          <button
            className="modal-close-btn"
            onClick={() => setShow(false)}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <Addstocks getPosts={getPosts} setShow={setShow} />
        </Modal.Body>
      </Modal>

      {/* EDIT MODAL */}
      <Modal
        show={showEdit}
        size="lg"
        centered
        onHide={() => setShowEdit(false)}
      >
        <Modal.Header className="modal-header-custom">
          <Modal.Title>Edit Stock Trade</Modal.Title>
          <button
            className="modal-close-btn"
            onClick={() => setShowEdit(false)}
            aria-label="Close"
          >
            <X size={20} />
          </button>
        </Modal.Header>
        <Modal.Body className="modal-body-custom">
          <EditStock
            editData={selectedData}
            setShow={setShowEdit}
            getData={getPosts}
          />
        </Modal.Body>
      </Modal>

      {loader && <Loader />}
    </div>
  );
}

/* ================= TABLE ================= */

const StockTable = ({
  data,
  page,
  setPage,
  limit,
  noOfPost,
  deletePost,
  onEdit,
  onAdd,
}) => {
  const formatDate = (date) => moment(date).format("MMM D, YYYY • h:mm A");

  return (
      <div className="table-responsive">
        <table className="crypto-trades-table">
          <thead>
            <tr>
              <th scope="col">IMAGE</th>
              <th scope="col">VIDEO</th>
              <th scope="col">FILE</th>
              <th scope="col">DESCRIPTION</th>
              <th scope="col">CREATED BY</th>
              <th scope="col">CREATED AT</th>
              <th scope="col" className="text-center">ACTIONS</th>
            </tr>
          </thead>

          <tbody>
            {data.length > 0 ? (
              data.map((item, idx) => (
                <tr key={idx} className="crypto-trade-row">
                  <td>{item.imageTitle ? "Image" : "-"}</td>

                  <td>{item.video ? <Video size={16} /> : "-"}</td>

                  <td>
                    {item.pdfFile ? (
                      <a
                        className="file-link"
                        href={`${process.env.REACT_APP_S3URL}/${item.pdfFile}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <span className="file-icon pdf-icon">
                          <FileText size={18} />
                        </span>
                        <span className="file-name">Download</span>
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td className="description-container">
                    <div
                      className="description-content"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </td>

                  <td>
                    <div className="creator-info">
                      <div className="creator-avatar">
                        {item?.createdBy?.email?.[0]?.toUpperCase()}
                      </div>
                      <div className="creator-details">
                        <span className="creator-email">
                          {item?.createdBy?.email}
                        </span>
                        <span className="creator-role">Admin</span>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className="date-info">
                      <div className="date-icon">
                        <Calendar size={16} />
                      </div>
                      <div className="date-details">
                        <span className="date-formatted">
                          {moment(item.createdAt).format("MMM D, YYYY")}
                        </span>
                        <span className="time-ago">
                          {moment(item.createdAt).fromNow()}
                        </span>
                      </div>
                    </div>
                  </td>

                  <td>
                    <div className="action-buttons">
                      <button
                        className="action-btn edit-btn"
                        onClick={() => onEdit(item)}
                      >
                        <Edit2 size={16} />
                      </button>

                      <button
                        className="action-btn delete-btn"
                        onClick={() => deletePost(item._id)}
                      >
                        <Trash2 size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="empty-table-message">
                  <div className="empty-state">
                    <div className="empty-state-icon">📉</div>
                    <h3 className="empty-state-title">No Stock Posts Found</h3>
                    <p className="empty-state-description">
                      Start by adding your first stock trade
                    </p>
                    <button className="empty-state-btn" onClick={onAdd}>
                      + Add First Trade
                    </button>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>

      {/* Show pagination only when there's data */}
      {data.length > 0 && (
        <div className="pagination-container">
          <Pagination
            page={page}
            count={Math.ceil(noOfPost / limit)}
            onChange={(e, v) => setPage(v)}
          />
        </div>
      )}
    </div>
  );
};